// extracted by mini-css-extract-plugin
export var container = "_dl-0";
export var icon = "_dl-1";
export var text = "_dl-2";